import { safeSessionStorage, useAuthentication } from '@psyomics/ui-common';
import { LoadingSpinner, LoggedOut, PageLayout } from '@psyomics/ui-components';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useOrgCodeFromSession = () => {
  const [orgCode, setOrgCode] = useState<string | undefined>(undefined);
  useEffect(() => {
    const loggedOutOrgCode = safeSessionStorage.getItem('loggedOutOrgCode');
    if (loggedOutOrgCode) {
      safeSessionStorage.removeItem('loggedOutOrgCode');
      setOrgCode(loggedOutOrgCode);
    }
  }, []);

  return orgCode;
};

const LoggedOutView = () => {
  const [loading, setLoading] = useState(true);
  const [automaticSso, setAutomaticSso] = useState(false);
  const navigate = useNavigate();
  const { getOrgSettings } = useAuthentication();

  const orgCode = useOrgCodeFromSession();

  useEffect(() => {
    (async () => {
      if (orgCode) {
        const organisation = await getOrgSettings(orgCode);
        setAutomaticSso(!organisation.defaultClientId);
      }
      setLoading(false);
    })();
  }, [setAutomaticSso, getOrgSettings, orgCode]);

  const handleSignInClick = useCallback(() => {
    navigate(`../account/${orgCode}`);
  }, [navigate, orgCode]);

  return (
    <PageLayout align="center" width="narrow">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <LoggedOut automaticSso={automaticSso} handleSignIn={orgCode !== undefined ? handleSignInClick : undefined} />
      )}
    </PageLayout>
  );
};

export { LoggedOutView };
